import * as React from 'react';
import ProviderProfile from '../components/Profile/ProviderProfile';

function ProviderMyProfile() {
    return (
        <ProviderProfile/>
    );
};

export default ProviderMyProfile;